import axios from 'axios'
import { writable } from 'svelte/store'
import {
  stops,
  stopArrivalTimes,
  mapVehiclePoints,
  routes,
  routesForMapWithScheduleWithEncodedLine,
} from './store.js'

export const rdyRideAPI = {
  domain: '',
  routeId: null, // one id or null for all
  fetchingRoutesForMapWithScheduleWithEncodedLine: false,
  fetchingStops: false,
  fetchingRoutes: false,
  fetchingStopArrivalTimes: false,
  fetchingMapVehiclePoints: false,
  routesForMapWithScheduleWithEncodedLine: async () => {
    rdyRideAPI.fetchingRoutesForMapWithScheduleWithEncodedLine = true
    rdyRideAPI
      .getRequest({
        endpoint: 'RoutesForMapWithScheduleWithEncodedLine',
      })
      .then((response) => {
        console.log(response.data)
        routesForMapWithScheduleWithEncodedLine.set([...response.data])
        rdyRideAPI.fetchingRoutesForMapWithScheduleWithEncodedLine = false
        return response.data
      })
      .catch((err) => {
        console.log(err)
        rdyRideAPI.fetchingRoutesForMapWithScheduleWithEncodedLine = false
        return err
      })
  },
  stops: async () => {
    rdyRideAPI.fetchingStops = true
    rdyRideAPI
      .getRequest({ endpoint: 'Stops' })
      .then((response) => {
        console.log(response.data)
        stops.set([...response.data])
        rdyRideAPI.fetchingStops = false
        return response.data
      })
      .catch((err) => {
        console.log(err)
        rdyRideAPI.fetchingStops = false
        return err
      })
  },
  stopArrivalTimes: async () => {
    rdyRideAPI.fetchingStopArrivalTimes = true
    rdyRideAPI
      .getRequest({ endpoint: 'StopArrivalTimes' })
      .then((response) => {
        console.log(response.data)
        stopArrivalTimes.set([...response.data])
        rdyRideAPI.fetchingStopArrivalTimes = false
        return response.data
      })
      .catch((err) => {
        console.log(err)
        rdyRideAPI.fetchingStopArrivalTimes = false
        return err
      })
  },
  mapVehiclePoints: async () => {
    rdyRideAPI.fetchingMapVehiclePoints = true
    rdyRideAPI
      .getRequest({ endpoint: 'MapVehiclePoints' })
      .then((response) => {
        console.log(response.data)
        mapVehiclePoints.set([...response.data])
        rdyRideAPI.fetchingMapVehiclePoints = false
        return response.data
      })
      .catch((err) => {
        console.log(err)
        rdyRideAPI.fetchingMapVehiclePoints = false
        return err
      })
  },
  routes: async () => {
    rdyRideAPI.fetchingRoutes = true
    rdyRideAPI
      .getRequest({ endpoint: 'Routes' })
      .then((response) => {
        console.log(response.data)
        routes.set([...response.data])
        rdyRideAPI.fetchingRoutes = false
        return response.data
      })
      .catch((err) => {
        console.log(err)
        rdyRideAPI.fetchingRoutes = false
        return err
      })
  },
  getRequest: async (args = {}) => {
    let apiRoute = rdyRideAPI.domain + '/wp-json/rdyride/v1/' + args.endpoint
    apiRoute +=
      rdyRideAPI.routeId !== null &&
      args.endpoint !== 'RoutesForMapWithScheduleWithEncodedLine'
        ? '/' + rdyRideAPI.routeId
        : ''
    return await axios
      .get(apiRoute)
      .then((response) => {
        // console.log(response);
        return response
      })
      .catch((error) => {
        // console.log(error);
        return error
      })
  },
}
